import { InjectionToken } from '@angular/core';

import {Config, Environment} from './environment.interface';

/**
 * @const ENVIRONMENT
 * Injection token for the environment interface to be provided by the applications.
 */
export const ENVIRONMENT: InjectionToken<Environment> = new InjectionToken('ENVIRONMENT');
export const CONFIG: InjectionToken<Config> = new InjectionToken('CONFIG');
Window
